import { render, staticRenderFns } from "./InputListComponent.vue?vue&type=template&id=2e2c3d23&"
import script from "./InputListComponent.vue?vue&type=script&lang=ts&"
export * from "./InputListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports